/**
 * @typedef {Object} SelectionItem
 * @property {String} currency
 * @property {Boolean} is_paid
 * @property {Number} item_id
 * @property {Number} item_price
 * @property {Number} item_quantity
 * @property {Number} item_quantity_diff
 * @property {String} item_text
 * @property {Object} passenger_data
 * @property {String} passenger_data.category_code
 * @property {String} passenger_data.host_child_id
 * @property {Number} passenger_data.host_id
 * @property {String} passenger_data.literals
 * @property {Number} passenger_id
 * @property {Number} segment_id
 */

var SvcsScreenSeats = (function ($) {

    SvcsScreenSeats = function (options) {
        var that = this;

        that.class = {
            select_segment_passengers_js: 'js-select-segment-passengers',

            seatmap: 'seatmap',
            seatmap_js: 'js-seatmap',
            seatmap_head: 'seatmap-head',
            seatmap_current: 'current',
            seatmap_drawer_content: 'svcs-seats-seatmap-drawer-content',

            svc_action_submit: 'js-svc-action-submit',
            svc_action_submit_text_desktop: 'js-svc-action-submit-text-desktop',
            svc_action_submit_text_mobile: 'js-svc-action-submit-text-mobile',

            add_drawer_total: 'js-svcs-seats-total-value'
        };

        that.selectors = {
            select_passenger_wrap_select: '.js-select-passenger-wrap-action-select',
            select_passenger_badge: '.js-select-passenger-badge',
            select_passenger_action_select: '.js-select-passenger-action-select',
            select_passengers_actions: '.js-select-passengers-actions',

            seatmap: '.js-seatmap',
            seatmap_current: '.js-seatmap.current',
            seatmap_head_flight_name: '.js-seatmap-head-flight-name',
            seatmap_head_flight_desc: '.js-seatmap-head-flight-description',
            seatmap_head_seat_letters: '.js-seatmap-head-letters',
            seatmap_main: '.js-seatmap-cabin',

            seats_description: '.js-seats-description',

            select_segment_passengers: UISelectSegmentPassengers.prototype.selectors.select_segment_passengers,
            select_segment_passengers_current: UISelectSegmentPassengers.prototype.selectors.select_segment_current,
            select_passengers: UISelectSegmentPassengers.prototype.selectors.select_passengers
        };

        that.options = options;

        that.$wrapper = that.options['$wrapper'];

        if (that.$wrapper && that.$wrapper.length) {
            // DOM
            that.$select_segment_passengers = that.$wrapper.find(that.selectors.select_segment_passengers);

            that.$seatmaps = that.$wrapper.find(that.selectors.seatmap);
            that.$seats_description = that.$wrapper.find(that.selectors.seats_description);
            that.$add_drawer_total = that.$wrapper.find('.' + that.class.add_drawer_total);

            // CONST
            that.locales = Object.assign({},
                {
                    seatmap_submit_btn_empty: '',
                    seatmap_submit_btn_added: '',
                    seatmap_submit_btn_continue: '',
                    seatmap_submit_btn_confirm: ''
                },
                that.options.locales
            );
            that.modals = that.options.modals;
            that.segments_passengers = that.options['segments_passengers'] || [];
            that.passengers = that.options['passengers'] || [];
            that.order_currency = that.options['order_currency'] || '';
            that.order_segments_ids = that.options.order_segments_ids;
            that.order_passengers_ids = that.options.order_passengers_ids;
            
            that.items_unpaid_initial_count = that.__countItemsQuantity(that.options['items_unpaid'] || []);
            
            that.seats_incomplete_warning_enable = that.options['seats_incomplete_warning_enable'];
            that.seats_incomplete_warning_html = that.modals['seats_incomplete_warning_html'];
            
            that.seats_empty_warning_enable = that.options['seats_empty_warning_enable'];
            that.seats_empty_warning_html = that.modals['seats_empty_warning_html'];

            /**
             * @type {SelectionItem[]}
             */
            that.seats_selected_unpaid = [];

            /**
             * @type {SelectionItem[]}
             */
            that.seats_selected_paid = (that.options.hasOwnProperty('items_paid')) ? that.options.items_paid.slice() : [];

            // DYNAMIC VARS
            that.total_amount = 0;
            that.is_showed = false;
            that.seats_empty_modal_disallow = false;

            // HANDLERS
            that.onPassengerSelected = (that.options['onPassengerSelected'] || function () {});
            that.onPassengerReset = (that.options['onPassengerReset'] || function () {});
            that.onButtonConfirmClick = (that.options['onButtonConfirmClick'] || function () {});
            that.onSeatsIncompleteWarningCancelClosed = (that.options['onSeatsIncompleteWarningCancelClosed'] || function () {});
            that.onSeatsEmptyWarningCancelClosed = (that.options['onSeatsEmptyWarningCancelClosed'] || function () {});

            // COMPONENTS
            /**
             * @type {UISelectSegmentPassengers[]}
             */
            that.select_segment_passengers = [];

            /**
             * @type {UISeatmap[]}
             */
            that.seatmaps = [];
            that.select_segment_passengers_mobile = [];
            that.seatmaps_mobile = [];

            //ANALYTICS
            /** @type {AnalyticsSvcsDataset} */
            that.analytics_dataset = that.options.analytics_dataset || null;
            that.current_segment = null;

            // INIT
            that.init(options);
        }
    }

    SvcsScreenSeats.prototype.init = function (options = {}) {
        var that = this,
            first_passenger_to_focus,
            items_unpaid = options['items_unpaid'] || [];

        that.__assignPassengerDataToInitialSeats(items_unpaid);
        that.__assignPassengerDataToInitialSeats(that.seats_selected_paid);

        that.initSelectSegmentPassengers();

        that.initSeatmaps(items_unpaid);

        // initialize focus on first unselected passenger, or on the first passenger of all segments in case all passengers are selected
        // after seatmaps and passenger selectors initialization - IMPORTANT
        first_passenger_to_focus = that.__findFirstUnselectedPassenger();
        if (null === first_passenger_to_focus) {
            first_passenger_to_focus = that.__getFirstPassenger();
        }
        that.select_segment_passengers.forEach(function (select_segment_passengers) {
            if (select_segment_passengers.isThatSegment(first_passenger_to_focus['segment_id'])) {
                var $passenger = select_segment_passengers.getPassengerById(first_passenger_to_focus['passenger_id']);
                select_segment_passengers.focus($passenger);
            }
        });

        that.svcActionSubmitHandler();

        if (that.analytics_dataset && that.analytics_dataset.layout === 'svc_add') {
            var event_data;
            that.analytics_dataset.segment_directions.forEach(sd => {
                event_data = that.analytics_dataset.getViewItemListForType('SEAT_ASSIGNMENT', sd.id);
                if(event_data) {
                    event_data.item_list_name = event_data.item_list_name + ` (${sd.departure_airport_iata}-${sd.arrival_airport_iata})`;
                    $.sa.analytics.gtag('event', 'view_item_list', event_data);
                }
            });
        }
    };

    SvcsScreenSeats.prototype.onShow = function () {
        var that = this;

        if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
            $.sa.analytics.gtagSelectContent('page', 'main_seats_svcs');
        }

        // if there are initially default items,
        // they are shown only on Screen open event (onShow)
        if (!that.is_showed && that.options['items_default'] && that.options['items_default'].length) {
            var items_default = that.options['items_default'];

            that.__assignPassengerDataToInitialSeats(items_default);

            items_default.forEach(function (svc) {
                for (var seatmap of that.seatmaps) {
                    if (seatmap.isThatSegment(svc['segment_id'])) {
                        var $chair = seatmap.getChairByName(svc['item_text']);
                        seatmap.select($chair);
                        break;
                    }
                }
            });
        }

        that.is_showed = true;
    };

    SvcsScreenSeats.prototype.__setInitialSubmitActionState = function () {
        var that = this;
        // if there were any unpaid items on init - set Confirm state
        if (that.items_unpaid_initial_count > 0) {
            that.__setActionSubmitConfirm();
        }
        // if there were no unpaid items, but there are any paid items - set Continue state
        else if (that.seats_selected_paid && that.seats_selected_paid.length) {
            that.__setActionSubmitContinue();
        }
        // if there were no unpaid items on init, and no paid items - set Empty state
        else {
            that.__setActionSubmitEmpty();
        }
    };

    SvcsScreenSeats.prototype.svcActionSubmitHandler = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svc_action_submit);

        $action.on('click', function (event) {
            var $this = $(this);

            that.onButtonConfirmClick(that.seats_selected_unpaid, that, event);
        });
    };

    SvcsScreenSeats.prototype.initSelectSegmentPassengers = function () {
        var that = this;

        that.$select_segment_passengers.each(function () {
            that.select_segment_passengers.push(
                // in Passengers Selectors pass only paid items
                // (because unpaid ones would be passed into Seatmaps, and then they would be applied to Passengers Selectors in callbacks)
                new UISelectSegmentPassengers({
                    $wrapper: $(this),
                    $container: that.$wrapper,
                    items_paid: that.seats_selected_paid,
                    segment_currency: that.order_currency,
                    onPassengerReset: function (data, call_callback_after, component) {
                        // FIXME: `data` could be an array of objects
                        // reset seats on seatmaps
                        that.seatmaps.forEach(function (seatmap) {
                            // need to pass exactly component's segment_id IMPORTANT
                            if (seatmap.isThatSegment(component.segment_id)) {
                                seatmap.reset(data.item_text, false); // do not call callback - recursion call would be triggered
                            }
                        });

                        that.__resetSvc(data);

                        var quantity = that.__getQuantityAll();
                        // Update submit button state
                        if (quantity === 0) {
                            if (that.seats_selected_paid && that.seats_selected_paid.length) {
                                that.__setActionSubmitConfirm();
                            } else {
                                that.__setActionSubmitEmpty();
                            }
                        }
                        // if quantity was dropped to initial value - set initial state
                        else if (quantity === that.items_unpaid_initial_count) {
                            that.__setInitialSubmitActionState();
                        }
                        // if quantity was dropped, but current quantity is still greater than initial one - set Add state
                        else if (quantity > that.items_unpaid_initial_count) {
                            that.__setActionSubmitAdd(quantity > 1);
                        }
                        // if quantity was dropped, and current quantity is lesser than initial one - set Confirm state
                        else {
                            that.__setActionSubmitConfirm();
                        }

                        if (data.hasOwnProperty('item_price')) {
                            that.total_amount = that.__recalcSvcTotal(that.total_amount, data['item_price'], data['item_quantity_diff']);
                            that.__displaySvcTotal(that.total_amount);
                        } else {
                            $.sa.log('Could not count seats total price: missing data');
                        }

                        // callback from parent
                        that.onPassengerReset(data, that);
                    },
                    afterPassengerReset: function (data, component) {
                        // focus the current passenger (the passenger who was reset just now)
                        var $passenger = component.getPassengerById(data.passenger_id);
                        component.focus($passenger);
                    },
                    afterSegmentReset: function (segment_id, component) {
                        // focus the first passenger in this segment
                        component.focus(component.getSegmentFirstPassenger());
                    },
                    afterPassengerSelected: function (data, component) {
                        var $passenger = component.getPassengerById(data.passenger_id),
                            $next_passenger = component.getNextSegmentPassenger($passenger);

                        // if all passengers in segment are selected now - collapse segment;
                        // but if all other segments are also fully selected - do not collapse
                        if (
                            !component.getFirstUnselectedSegmentPassenger().length &&
                            component.getFirstUnselectedPassengerNextSegment().length
                        ) {
                            component.collapseSegment();
                        }

                        // if current passenger is not the last in the segment,
                        // focus the next passenger in that segment
                        if ($next_passenger.length) {
                            component.focus($next_passenger);
                        }
                        else {
                            // otherwise, try to focus the fist passenger in the next segment
                            var next_select_segment_passengers = that.__getNextSegmentSelector(data.segment_id);
                            // or, if current segment is the last, focus the fist passenger in the first segment
                            if (next_select_segment_passengers === null) {
                                next_select_segment_passengers = that.__getFirstSegmentSelectorAvailable();
                            }
                            $next_passenger = next_select_segment_passengers.getSegmentFirstPassenger();
                            next_select_segment_passengers.focus($next_passenger);
                        }
                    },
                    onPassengerFocused: function (data, initialize_selection, component) {
                        var event_data;

                        // show seatmap, related to selected segment and passenger, and hide all others
                        that.seatmaps.forEach(function (seatmap) {
                            // toggle seatmap current
                            //FIXME: `data.segment_id` could be stringified array (e.g. '11,22,33')
                            seatmap.toggleSeatmap(data.segment_id);
                            // and save new passenger's data
                            if (!component.isTheSamePassenger(data.passenger_id, seatmap.current_passenger.id)) {
                                seatmap.changePassenger(data.passenger_id, data.passenger_data);
                            }
                        });

                        if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
                            var segment = that.analytics_dataset.getSegmentDirectionBySegmentId(data.segment_id);
                            if (segment && that.current_segment && segment.segment_id.toString() !== that.current_segment.toString()) {
                                that.current_segment = segment.segment_id;
                                event_data = that.analytics_dataset.getViewItemListForType('SEAT_ASSIGNMENT', segment.segment_id);
                                if (event_data) {
                                    event_data.item_list_name = event_data.item_list_name + ` (${segment.departure_airport_iata}-${segment.arrival_airport_iata})`;
                                    $.sa.analytics.gtag('event', 'view_item_list', event_data);
                                }

                            }
                        }
                        // initialize mobile drawer, only if user has selected passenger manually
                        if (initialize_selection && !$.sa.is_desktop()) {
                            that.__initSeatmapDrawer(data);
                        }
                    }
                })
            );
        });
    };

    SvcsScreenSeats.prototype.initSeatmaps = function (seats_selected_initial = []) {
        var that = this;

        that.$seatmaps.each(function () {
            that.seatmaps.push(
                // in Seatmaps pass only unpaid items
                // (because paid ones are already displayed in the template)
                new UISeatmap({
                    $wrapper: $(this),
                    $seats_description: that.$seats_description,
                    selected_seats_unpaid: seats_selected_initial,
                    modals: that.modals.seatmap || {},
                    locales: {
                        places: that.locales['seatmap_places'] || '',
                        places_not_selected: that.locales['seatmap_places_not_selected'] || '',
                        tooltip_not_for_infant: that.locales['seatmap_tooltip_not_for_infant'] || '',
                        tooltip_not_for_infant_and_children: that.locales['seatmap_tooltip_not_for_infant_and_children'] || '',
                        tooltip_not_for_unaccompanied_child: that.locales['seatmap_tooltip_not_for_unaccompanied_child'] || '',
                    },
                    onSeatReset: function (data, component) {
                        // reset item in Passengers Selector
                        that.select_segment_passengers.forEach(function (select_segment_passengers) {
                            if (select_segment_passengers.isThatSegment(data['segment_id'])) {
                                select_segment_passengers.resetPassenger(data['passenger_id'], false, true); // do not call callback - recursion call would be triggered
                            }
                        });

                        that.__resetSvc(data);

                        var quantity = that.__getQuantityAll();
                        // Update submit button state
                        if (quantity === 0) {
                            if (that.seats_selected_paid && that.seats_selected_paid.length) {
                                that.__setActionSubmitConfirm();
                            } else {
                                that.__setActionSubmitEmpty();
                            }
                        }
                        // if quantity was dropped to initial value - set initial state
                        else if (quantity === that.items_unpaid_initial_count) {
                            that.__setInitialSubmitActionState();
                        }
                        // if quantity was dropped, but current quantity is still greater than initial one - set Add state
                        else if (quantity > that.items_unpaid_initial_count) {
                            that.__setActionSubmitAdd(quantity > 1);
                        }
                        // if quantity was dropped, and current quantity is lesser than initial one - set Confirm state
                        else {
                            that.__setActionSubmitConfirm();
                        }

                        if (data.hasOwnProperty('item_price')) {
                            that.total_amount = that.__recalcSvcTotal(that.total_amount, data['item_price'], data['item_quantity_diff']);
                            that.__displaySvcTotal(that.total_amount);
                        } else {
                            $.sa.log('Could not count seats total price: missing data');
                        }

                        // callback from parent
                        that.onPassengerReset(data, that);
                    },
                    onSeatSelected: function (data, component) {
                        var item_is_paid = data.hasOwnProperty('is_paid') ? !!data.is_paid : false;
                        if (!item_is_paid) {
                            // show selected item in Passengers Selector
                            that.select_segment_passengers.forEach(function (select_segment_passengers) {

                                if (select_segment_passengers.isThatSegment(data['segment_id'])) {

                                    select_segment_passengers.select(
                                        data['passenger_id'],
                                        data['item_id'],
                                        data['item_price'],
                                        {
                                            item_text: data['item_text']
                                        }
                                    );
                                }
                            });
                        }

                        that.__saveSvc(data);

                        // Update submit button state
                        var quantity = that.__getQuantityAll();
                        // if quantity was set to initial value - set initial state
                        if (quantity === that.items_unpaid_initial_count) {
                            that.__setInitialSubmitActionState();
                        }
                        // if current quantity is lesser than initial one - set Confirm state
                        else if (quantity < that.items_unpaid_initial_count) {
                            that.__setActionSubmitConfirm();
                        }
                        // if current quantity is greater than initial one - set Add state
                        else {
                            that.__setActionSubmitAdd(quantity > 1);
                        }

                        if (data.hasOwnProperty('item_price')) {
                            that.total_amount = that.__recalcSvcTotal(that.total_amount, data['item_price'], data['item_quantity_diff']);
                            that.__displaySvcTotal(that.total_amount);
                        } else {
                            $.sa.log('Could not count seats total price: missing data');
                        }

                        // callback from parent
                        that.onPassengerSelected(data, that);
                    },
                    beforeSeatSelected: function (segment_id, passenger_id, component) {
                        var select_segment_passengers = that.select_segment_passengers.find(select_segment_passengers => select_segment_passengers.isThatSegment(segment_id));
                        // reset previously selected seat for specified passenger
                        if (select_segment_passengers) {
                            select_segment_passengers.resetPassenger(passenger_id);
                        }
                    },
                    navigatePrev: function ($seatmap, $seatmaps_wrapper, component) {
                        var prev_select_segment_passengers,
                            prev_select_segment_passengers_index,
                            $passenger;

                        for (var index = 0; index < that.select_segment_passengers.length; index++) {

                            var select_segment_passengers = that.select_segment_passengers[index];

                            if (select_segment_passengers.isThatSegment(component.segment_id)) {
                                if (index === 0) {
                                    break;
                                }
                                prev_select_segment_passengers_index = index - 1;
                                prev_select_segment_passengers = that.select_segment_passengers[prev_select_segment_passengers_index];
                                break;
                            }
                        }

                        if (!prev_select_segment_passengers) {
                            return;
                        }

                        // focus on either the first unselected passenger in the target segment,
                        // or first passenger in the target segment (even if it's selected passenger)
                        $passenger = prev_select_segment_passengers.getFirstUnselectedSegmentPassenger();
                        if (!$passenger.length) {
                            $passenger = prev_select_segment_passengers.getSegmentFirstPassenger();
                        }
                        prev_select_segment_passengers.focus($passenger);
                    },
                    navigateNext: function ($seatmap, $seatmaps_wrapper, component) {
                        var next_select_segment_passengers,
                            next_select_segment_passengers_index,
                            $passenger;

                        for (var index = 0; index < that.select_segment_passengers.length; index++) {

                            var select_segment_passengers = that.select_segment_passengers[index];

                            if (select_segment_passengers.isThatSegment(component.segment_id)) {
                                if (index === that.select_segment_passengers.length - 1) {
                                    break;
                                }
                                next_select_segment_passengers_index = index + 1;
                                next_select_segment_passengers = that.select_segment_passengers[next_select_segment_passengers_index];
                                break;
                            }
                        }

                        if (!next_select_segment_passengers) {
                            return;
                        }

                        // focus on either the first unselected passenger in the target segment,
                        // or first passenger in the target segment (even if it's selected passenger)
                        $passenger = next_select_segment_passengers.getFirstUnselectedSegmentPassenger();
                        if (!$passenger.length) {
                            $passenger = next_select_segment_passengers.getSegmentFirstPassenger();
                        }
                        next_select_segment_passengers.focus($passenger);
                    }
                })
            );
        });
    };

    /**
     * @param {SelectionItem} data
     * @private
     */
    SvcsScreenSeats.prototype.__saveSvc = function (data) {
        var that = this,
            item_changed_index = that.seats_selected_unpaid.length ? that.seats_selected_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString() &&
                    selection.item_text               === data.item_text
                )
            ) : -1,
            quantity = data.item_quantity ? parseInt(data.item_quantity, 10) : 0,
            quantity_diff = data.item_quantity_diff ? parseInt(data.item_quantity_diff, 10) : 0;

        // if item is already saved, update quantity
        if (item_changed_index !== -1) {
            that.seats_selected_unpaid[item_changed_index]['item_quantity'] = quantity;
            that.seats_selected_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;
        } else {
            that.seats_selected_unpaid.push(data);
        }

        if(that.analytics_dataset && that.analytics_dataset.layout === 'main') {
            var cart_change = that.analytics_dataset.svcCartChange(data);
            if (cart_change.add_to_cart) {
                $.sa.analytics.gtag('event', 'add_to_cart', cart_change.add_to_cart);
            }

            if (cart_change.remove_from_cart) {
                $.sa.analytics.gtag('event', 'remove_from_cart', cart_change.remove_from_cart);
            }
        }
    };

    /**
     * @param {Object} data
     * @param {String} data.currency
     * @param {String|Number} data.item_id
     * @param {Number} data.item_quantity
     * @param {Number} data.item_quantity_diff
     * @param {String} data.item_text
     * @param {Number} data.passenger_id
     * @param {Number} data.segment_id
     * @private
     */
    SvcsScreenSeats.prototype.__resetSvc = function (data) {
        var that = this,
            item_changed_index = that.seats_selected_unpaid.findIndex(selection => (
                    selection.segment_id.toString()   === data.segment_id.toString() &&
                    selection.passenger_id.toString() === data.passenger_id.toString() &&
                    selection.item_id.toString()      === data.item_id.toString() &&
                    selection.item_text               === data.item_text
                )
            ),
            quantity,
            quantity_diff;

        // remove item
        if (item_changed_index === -1) {
            $.sa.log('Error reset seat: not exists in set of selections');
            return;
        }
        quantity = that.seats_selected_unpaid[item_changed_index]['item_quantity'];
        if (quantity <= 0) {
            $.sa.log('Error reset seat: it was already reset');
            return;
        }

        quantity_diff = -quantity;

        that.seats_selected_unpaid[item_changed_index]['item_quantity'] = 0;
        that.seats_selected_unpaid[item_changed_index]['item_quantity_diff'] = quantity_diff;

        if(that.analytics_dataset && that.analytics_dataset.layout === 'main') {
            var cart_change = that.analytics_dataset.svcCartChange(data);
            if (cart_change.add_to_cart) {
                $.sa.analytics.gtag('event', 'add_to_cart', cart_change.add_to_cart);
            }

            if (cart_change.remove_from_cart) {
                $.sa.analytics.gtag('event', 'remove_from_cart', cart_change.remove_from_cart);
            }
        }
    };

    SvcsScreenSeats.prototype.__initSeatmapDrawer = function (init_seatmap_data = {}) {
        var that = this,
            $select_segment_passengers_current = that.$wrapper.find(that.selectors.select_segment_passengers_current),
            $select_passengers_current = $select_segment_passengers_current.find(that.selectors.select_passengers),
            $seatmap_current = that.$wrapper.find(that.selectors.seatmap_current);

        if (!$select_passengers_current.length || !$seatmap_current.length) {
            return;
        }

        var $seatmap_head_flight_name = $seatmap_current.find(that.selectors.seatmap_head_flight_name).clone(),
            $seatmap_head_flight_desc = $seatmap_current.find(that.selectors.seatmap_head_flight_desc).clone(),
            $seatmap_head_seat_letters = $seatmap_current.find(that.selectors.seatmap_head_seat_letters).clone(),
            $seatmap_main = $seatmap_current.find(that.selectors.seatmap_main).clone(),
            $select_passengers_clone = $select_passengers_current.clone(),
            segment_id = UISelectSegmentPassengers.prototype.getSegmentId($select_segment_passengers_current),
            select_segment_passengers_type = $select_segment_passengers_current.data(UISelectSegmentPassengers.prototype.data_keys.select_segment_type);

        $select_passengers_clone.find(that.selectors.select_passengers_actions).remove();

        var $seatmap_drawer_head = $('<div />').addClass(that.class.seatmap_head), // preserve class .seatmap-head, to set proper styles
            $select_segment_passengers = $('<div />').addClass(that.class.select_segment_passengers_js), // preserve class .js-select-segment-passengers, to set proper scripts
            $content = $('<div />').addClass(that.class.seatmap_drawer_content);

        $select_segment_passengers.append($select_passengers_clone);

        $seatmap_drawer_head
            .append($select_segment_passengers)
            .append($seatmap_head_seat_letters);

        $content.append($seatmap_main);

        var getSubmitButtonText = function (quantity, total, quantity_initial) {
            if (quantity === 0) {
                if (that.seats_selected_paid && that.seats_selected_paid.length) {
                    return that.locales.seatmap_submit_btn_confirm;
                } else {
                    return that.locales.seatmap_submit_btn_empty;
                }
            }
            // if quantity was dropped to initial value - set initial state
            else if (quantity === quantity_initial) {
                return getSubmitButtonTextInitial(quantity_initial);
            }
            // if quantity was dropped, but current quantity is still greater than initial one - set Add state
            else if (quantity > quantity_initial) {
                return that.locales.seatmap_submit_btn_added + ' ' + that.__formatTotalPrice(total);
            }
            // if quantity was dropped, and current quantity is lesser than initial one - set Confirm state
            else {
                return that.locales.seatmap_submit_btn_confirm;
            }
        };

        var getSubmitButtonTextInitial = function (quantity_initial) {
            // if there were any unpaid items on init - set Confirm state
            if (quantity_initial > 0) {
                return that.locales.seatmap_submit_btn_confirm;
            }
            // if there were no unpaid items, but there are any paid items - set Continue state
            else if (that.seats_selected_paid && that.seats_selected_paid.length) {
                return that.locales.seatmap_submit_btn_continue;
            }
            // if there were no unpaid items on init, and no paid items - set Empty state
            else {
                return that.locales.seatmap_submit_btn_empty;
            }
        };

        // selected seats in current segment (deep clone)
        var selections = JSON.parse(JSON.stringify(
            that.seats_selected_unpaid.filter(selection =>
                selection.segment_id.toString() === segment_id.toString()
            )
        ));

        var saveSvcInTemporaryCollection = function (svc_data) {
            var item_changed_index = selections.findIndex(selection => (
                    selection.segment_id.toString()     === svc_data.segment_id.toString() &&
                    selection.passenger_id.toString()   === svc_data.passenger_id.toString() &&
                    selection.item_id.toString()        === svc_data.item_id.toString() &&
                    selection.item_text                 === svc_data.item_text
                )),
                quantity = svc_data.item_quantity ? parseInt(svc_data.item_quantity, 10) : 0,
                quantity_prev,
                quantity_diff;

            // if item found, update quantity
            if (item_changed_index !== -1) {
                quantity_prev = selections[item_changed_index]['item_quantity'];
                quantity_diff = quantity - quantity_prev;

                selections[item_changed_index]['item_quantity'] = quantity;
                selections[item_changed_index]['item_quantity_diff'] = quantity_diff;
            }
            // if item wasn't saved yet, save it now
            else {
                quantity_diff = quantity;
                svc_data['item_quantity_diff'] = quantity_diff;
                selections.push(svc_data);
            }
        };

        var resetSvcInTemporaryCollection = function (svc_data) {
            var item_changed_index = selections.findIndex(selection => (
                    selection.segment_id.toString()     === svc_data.segment_id.toString() &&
                    selection.passenger_id.toString()   === svc_data.passenger_id.toString() &&
                    selection.item_id.toString()        === svc_data.item_id.toString() &&
                    selection.item_text                 === svc_data.item_text
                )),
                quantity_prev,
                quantity_diff;

            if (item_changed_index === -1) {
                return;
            }

            // if item found, update quantity
            quantity_prev = selections[item_changed_index]['item_quantity'];
            quantity_diff = -quantity_prev;

            selections[item_changed_index]['item_quantity'] = 0;
            selections[item_changed_index]['item_quantity_diff'] = quantity_diff;
        };

        var countSelectionsQuantity = function () {
            if (!selections.length) {
                return 0;
            }
            return selections.reduce(function (quantity, selection) {
                return quantity + parseInt(selection['item_quantity'], 10);
            }, 0);
        };

        var countSelectionsTotal = function () {
            if (!selections.length) {
                return 0;
            }
            return selections.reduce(function (total, selection) {
                var item_quantity = selection.hasOwnProperty('item_quantity') ? parseInt(selection['item_quantity'], 10) : 0,
                    item_price = selection.hasOwnProperty('item_price') ? parseFloat(selection['item_price']) : 0;
                return total + item_price * item_quantity;
            }, 0);
        };

        var sortSelections = function (selection_data_1, selection_data_2) {
            var selection_quantity_1 = parseInt(selection_data_1.item_quantity, 10),
                selection_quantity_2 = parseInt(selection_data_2.item_quantity, 10);
            if (
                selection_quantity_1 <= 0 &&
                selection_quantity_2 > 0
            ) {
                return -1;
            }
            if (
                selection_quantity_2 <= 0 &&
                selection_quantity_1 > 0
            ) {
                return 1;
            }
            return 0;
        };

        var selections_quantity_initial = countSelectionsQuantity();

        $.uiDrawer({
            position: 'right',
            mobile_fullscreen: true,
            header_title: $seatmap_head_flight_name,
            header_description: $seatmap_head_flight_desc,
            content: $content,
            content_fixed: $seatmap_drawer_head,
            button_confirm_text: getSubmitButtonTextInitial(selections_quantity_initial),
            custom_class: that.class.seatmap + ' ' + that.class.seatmap_current + ' ' + that.class.seatmap_js, // preserve classes `.seatmap .current .js-seatmap`, to set proper styles and apply scripts
            onOpen: function ($drawer_wrapper, drawer) {
                var timer = null; // timer to debounce scroll on focus

                // init Passenger Selector
                $drawer_wrapper.find(that.selectors.select_segment_passengers).each(function () {
                    that.select_segment_passengers_mobile.push(
                        new UISelectSegmentPassengers({
                            $wrapper: $(this),
                            $container: $drawer_wrapper,
                            segment_id: segment_id,
                            segment_currency: that.order_currency,
                            type: select_segment_passengers_type,
                            onPassengerReset: function (data, call_callback_after, component) {
                                var $button_confirm = $drawer_wrapper.find('.js-button-confirm');

                                resetSvcInTemporaryCollection(data);

                                // reset seats on seatmaps (only on mobile one - reset of Seatmaps on page would be performed in onReset from Passenger Selectors on page)
                                that.seatmaps_mobile.forEach(function (seatmap) {
                                    if (seatmap.isThatSegment(component.segment_id)) {
                                        seatmap.reset(data.item_text, false); // do not call callback - recursion call would be triggered
                                    }
                                });

                                // change submit button text
                                $button_confirm.text(getSubmitButtonText(
                                    countSelectionsQuantity(),
                                    countSelectionsTotal(),
                                    selections_quantity_initial
                                ));

                                // override badge styles
                                var $passenger = component.getPassengerById(data.passenger_id),
                                    $badge = $passenger.find(that.selectors.select_passenger_badge);
                                $badge.removeClass('coral').addClass('gray light');

                                // no callback from parent - it would be called from Passenger Selectors on page
                            },
                            afterPassengerReset: function (data, component) {
                                // focus the current passenger (the passenger who was reset just now)
                                var $passenger = component.getPassengerById(data.passenger_id);
                                component.focus($passenger);
                            },
                            afterPassengerSelected: function (data, component) {
                                // focus the next passenger
                                var $passenger = component.getPassengerById(data.passenger_id),
                                    $next_passenger = component.getNextSegmentPassenger($passenger);

                                // if there are any passengers below current one -
                                // focus the first of them;
                                // otherwise, if the current passenger is the last one in the segment - 
                                // return focus to the first passenger
                                if (!$next_passenger || !$next_passenger.length) {
                                    $next_passenger = component.getSegmentFirstPassenger();
                                }
                                component.focus($next_passenger);
                            },
                            onPassengerFocused: function (data, initialize_selection, component) {
                                var $passenger_focused = component.getPassengerById(data.passenger_id),
                                    $passengers_wrapper = $passenger_focused.parents(that.selectors.select_passengers),
                                    passengers_wrapper_scroll_left = $passengers_wrapper.scrollLeft(),
                                    passenger_focused_position_left = $passenger_focused.position().left,
                                    passengers_scroll_left_offset = 20;

                                timer && clearTimeout(timer);
                                timer = setTimeout(function () { // debounce to prevent extra scrolls on init (see: https://tracker.flysa.ru/browse/SMA-2836?focusedId=28848&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-28848)
                                    // scroll to focused passenger
                                    $passengers_wrapper.animate({
                                        scrollLeft: passengers_wrapper_scroll_left + passenger_focused_position_left - passengers_scroll_left_offset
                                    }, 500);
                                }, 10);

                                var select_segment_passengers_on_page = that.select_segment_passengers.find(select_segment_passengers => select_segment_passengers.isThatSegment(data.segment_id)),
                                    $passenger_on_page = select_segment_passengers_on_page ? select_segment_passengers_on_page.getPassengerById(data.passenger_id) : null;

                                // focus the same passenger on the page
                                if ($passenger_on_page && $passenger_on_page.length) {
                                    select_segment_passengers_on_page.focus($passenger_on_page);
                                }

                                // save new passenger's data in all seatmaps (mobile one and on the page)
                                [].concat(that.seatmaps_mobile, that.seatmaps).forEach(function (seatmap) {
                                    if (!select_segment_passengers_on_page.isTheSamePassenger(data.passenger_id, seatmap.current_passenger.id)) {
                                        seatmap.changePassenger(data.passenger_id, data.passenger_data);
                                    }
                                });
                            }
                        })
                    )
                });

                // override badge styles
                $drawer_wrapper.find(that.selectors.select_passenger_action_select).removeClass('coral').addClass('gray light');

                // init seatmap
                var options = {
                    segment_id: segment_id,
                    $seats_description: that.$seats_description,
                    modals: that.modals.seatmap || {},
                    locales: {
                        places: that.locales['seatmap_places'] || '',
                        places_not_selected: that.locales['seatmap_places_not_selected'] || '',
                        tooltip_not_for_infant: that.locales['seatmap_tooltip_not_for_infant'] || '',
                        tooltip_not_for_infant_and_children: that.locales['seatmap_tooltip_not_for_infant_and_children'] || '',
                        tooltip_not_for_unaccompanied_child: that.locales['seatmap_tooltip_not_for_unaccompanied_child'] || '',
                    },
                    beforeSeatSelected: function (segment_id, passenger_id, component) {
                        // reset previously selected seat for specified passenger
                        that.select_segment_passengers_mobile.forEach(function (select_segment_passengers) {
                            if (select_segment_passengers.isThatSegment(segment_id)) {
                                select_segment_passengers.resetPassenger(passenger_id);
                            }
                        });
                    },
                    onSeatSelected: function (data, component) {
                        var $button_confirm = $drawer_wrapper.find('.js-button-confirm');

                        saveSvcInTemporaryCollection(data);

                        // show selected item in Passengers Selector in drawer
                        // (don't need to do this for Passengers Selectors on page - it does seatmap.select())
                        that.select_segment_passengers_mobile.forEach(function (select_segment_passengers) {
                            if (select_segment_passengers.isThatSegment(data.segment_id)) {
                                select_segment_passengers.select(
                                    data['passenger_id'],
                                    data['item_id'],
                                    data['item_price'],
                                    {
                                        item_text: data['item_text']
                                    }
                                );
                            }
                        });

                        // change submit button text
                        $button_confirm.text(getSubmitButtonText(
                            countSelectionsQuantity(),
                            countSelectionsTotal(),
                            selections_quantity_initial
                        ));

                        // no callback from parent - it would be called from Seatmaps on page
                    },
                    onSeatReset: function (data, component) {
                        resetSvcInTemporaryCollection(data);

                        // reset item in Passengers Selector in drawer
                        // (don't need to do this for Passengers Selectors on page - it does seatmap.select())
                        that.select_segment_passengers_mobile.forEach(function (select_segment_passengers) {
                            if (select_segment_passengers.isThatSegment(data.segment_id)) {
                                select_segment_passengers.resetPassenger(data.passenger_id, false, true); // do not call callback - recursion call would be triggered
                                // override badge styles (do it here because callback is not called)
                                var $passenger = select_segment_passengers.getPassengerById(data.passenger_id),
                                    $badge = $passenger.find(that.selectors.select_passenger_badge);
                                $badge.removeClass('coral').addClass('gray light');
                            }
                        });

                        // no callback from parent - it would be called from Seatmaps on page
                    }
                };

                $drawer_wrapper.find(that.selectors.seatmap).each(function () {
                    that.seatmaps_mobile.push(
                        new UISeatmap(Object.assign({}, options, {$wrapper: $(this)}))
                    );
                });

                // focus passenger
                if (that.select_segment_passengers_mobile.length) {
                    var select_segment_passengers = init_seatmap_data.segment_id
                            ? that.select_segment_passengers_mobile.find(select_segment_passengers => select_segment_passengers.isThatSegment(init_seatmap_data.segment_id))
                            : that.select_segment_passengers_mobile[0],
                        $passenger_to_focus;

                    // if selector for specified segment_id was not found, use selector for the first segment
                    if (!select_segment_passengers) {
                        select_segment_passengers = that.select_segment_passengers_mobile[0];
                    }

                    // if passenger data is passed, focus specified passenger
                    if (
                        init_seatmap_data.passenger_id &&
                        init_seatmap_data.passenger_data
                    ) {
                        $passenger_to_focus = select_segment_passengers.getPassengerById(init_seatmap_data.passenger_id);
                    }
                    // if passenger data is not passed, or specified passenger was not found,
                    // focus either first unselected passenger
                    // (in the first segment, in case there are many of them and segment id is not specified)
                    if (!$passenger_to_focus || !$passenger_to_focus.length) {
                        $passenger_to_focus = select_segment_passengers.getFirstUnselectedSegmentPassenger();
                    }
                    // or, if every passenger is selected yet, focus the first passenger
                    if (!$passenger_to_focus || !$passenger_to_focus.length) {
                        $passenger_to_focus = select_segment_passengers.getSegmentFirstPassenger();
                    }
                    select_segment_passengers.focus($passenger_to_focus);
                }
            },
            onButtonConfirmClick: function (drawer, event) {
                // sort selections: items to reset - first, items to select - after them; otherwise, items on select could be reset right after their selection
                selections.sort(sortSelections);
                selections.forEach(function (selection) {
                    var item_quantity = parseInt(selection.item_quantity, 10);

                    // select seat on page
                    if (item_quantity > 0) {
                        // reset previously selected seat for specified passenger
                        that.select_segment_passengers.forEach(function (select_segment_passengers) {
                            if (select_segment_passengers.isThatSegment(segment_id)) {
                                select_segment_passengers.resetPassenger(selection.passenger_id);
                            }
                        });

                        // focus the same passenger on the page
                        var select_segment_passengers_on_page = that.select_segment_passengers.find(select_segment_passengers => select_segment_passengers.isThatSegment(selection.segment_id)),
                            $passenger = select_segment_passengers_on_page ? select_segment_passengers_on_page.getPassengerById(selection.passenger_id) : null;
                        if ($passenger && $passenger.length) {
                            select_segment_passengers_on_page.focus($passenger);
                        }

                        // save new passenger's data in all seatmaps (mobile one and on the page)
                        [].concat(that.seatmaps_mobile, that.seatmaps).forEach(function (seatmap) {
                            if (!select_segment_passengers_on_page.isTheSamePassenger(selection.passenger_id, seatmap.current_passenger.id)) {
                                seatmap.changePassenger(selection.passenger_id, selection.passenger_data);
                            }
                        });

                        // apply select to Seatmap on page
                        that.seatmaps.forEach(function (seatmap) {
                            if (seatmap.isThatSegment(selection.segment_id)) {
                                var $chair = seatmap.getChairByName(selection.item_text);
                                seatmap.select($chair);
                            }
                        });
                    }
                    // reset seat on page
                    else {
                        // TODO: `data` could be an array of objects
                        // apply reset to Passenger Selectors on page
                        that.select_segment_passengers.forEach(function (select_segment_passengers) {
                            if (select_segment_passengers.isThatSegment(selection.segment_id)) {
                                var $passenger = select_segment_passengers.getPassengerById(selection.passenger_id),
                                    $selection = select_segment_passengers.getPassengerSelection($passenger);
                                if ($selection && $selection.length) {
                                    select_segment_passengers.reset($selection); // FIXME: maybe need to pass `call_callback_after`
                                }
                            }
                        });
                    }
                });

                drawer.close();
            },
            onClose: function (drawer) {
                that.select_segment_passengers_mobile = [];
                that.seatmaps_mobile = [];
            },
            onResize: function ($drawer_wrapper, drawer) {
                if ($.sa.is_desktop()) {
                    drawer.close();
                }
            }
        });
    };

    SvcsScreenSeats.prototype.__findFirstUnselectedPassenger = function () {
        var that = this;

        if (!that.seats_selected_paid.length && !that.seats_selected_unpaid.length) {
            return null;
        }

        var selected_passengers_all = [].concat(that.seats_selected_unpaid, that.seats_selected_paid);

        // go through every existing segments
        for (var i = 0; i < that.segments_passengers.length; i++) {
            var segment_passenger = that.segments_passengers[i],
                selected_passenger = selected_passengers_all.find(selection => 
                    selection.segment_id.toString()   === segment_passenger.segment_id.toString() &&
                    selection.passenger_id.toString() === segment_passenger.passenger_id.toString()
                );

            // if passenger is not selected - return it
            if (!selected_passenger) {
                return {segment_id: segment_passenger.segment_id, passenger_id: segment_passenger.passenger_id};
            }
        }
        return null;
    };

    SvcsScreenSeats.prototype.__getFirstPassenger = function () {
        var that = this;
        return that.segments_passengers[0];
    };

    /**
     * Returns first available (not disabled) Passengers Selector
     * @private
     */
    SvcsScreenSeats.prototype.__getFirstSegmentSelectorAvailable = function () {
        var that = this;
        return that.select_segment_passengers.find(select_segment_passengers => !select_segment_passengers.isSegmentDisabled());
    };

    SvcsScreenSeats.prototype.__getNextSegmentSelector = function (segment_id) {
        var that = this,
            segment_index = that.select_segment_passengers.findIndex((select_segment_passengers) => select_segment_passengers.isThatSegment(segment_id));

        // if current selector is the last, return null
        if (segment_index === that.select_segment_passengers.length - 1) {
            return null;
        }

        var segments_after = that.select_segment_passengers.slice(segment_index + 1); // if element not found, index would be -1, so slice would be copy of initial set
        return (segments_after && segments_after.length) ? segments_after[0] : null;
    };

    SvcsScreenSeats.prototype.__assignPassengerDataToInitialSeats = function (seats_selected) {
        var that = this;

        var buildPassengerDataForSelection = function (selection) {
            if (!that.passengers.hasOwnProperty(selection.passenger_id)) {
                return {};
            }
            var passenger = that.passengers[selection.passenger_id];
            return {
                id: passenger.id,
                host_id: passenger.host_id || '',
                host_parent_id: passenger.host_parent_id || '',
                host_child_id: passenger.host_child_id || '',
                category_code: passenger.category_code || '',
                literals: $.sa.nameLiterals(passenger.firstname, passenger.lastname) || ''
            };
        };

        seats_selected.forEach(function (selection, index) {
            seats_selected[index].passenger_data = buildPassengerDataForSelection(selection);
        });
    };

    SvcsScreenSeats.prototype.__setActionSubmitEmpty = function () {
        var that = this;
        that.__setActionSubmitTextFor('empty');
        that.__setActionSubmitTypeCancel();
    };

    SvcsScreenSeats.prototype.__setActionSubmitAdd = function (plural = false) {
        var that = this;
        that.__setActionSubmitTextFor('added', plural);
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenSeats.prototype.__setActionSubmitConfirm = function () {
        var that = this;
        that.__setActionSubmitTextFor('confirm');
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenSeats.prototype.__setActionSubmitContinue = function () {
        var that = this;
        that.__setActionSubmitTextFor('continue');
        that.__setActionSubmitTypeConfirm();
    };

    SvcsScreenSeats.prototype.__setActionSubmitTextFor = function (state, plural = false, text_append = '') {
        var that = this,
            is_desktop = $.sa.is_desktop(),
            $action = that.$wrapper.find('.' + that.class.svc_action_submit),
            $action_text = is_desktop
                ? $action.find('.' + that.class.svc_action_submit_text_desktop)
                : $action.find('.' + that.class.svc_action_submit_text_mobile),
            text_key = state + '-text' + (plural ? '-plural' : ''),
            text = '' + $action_text.data(text_key) + text_append;
        $action_text.text(text);
    };

    SvcsScreenSeats.prototype.__setActionSubmitTypeCancel = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action_submit)
            .addClass(that.class.svc_action_cancel)
            .removeClass(that.class.svc_action_confirm);
    };

    SvcsScreenSeats.prototype.__setActionSubmitTypeConfirm = function () {
        var that = this;
        that.$wrapper.find('.' + that.class.svc_action_submit)
            .addClass(that.class.svc_action_confirm)
            .removeClass(that.class.svc_action_cancel);
    };

    SvcsScreenSeats.prototype.__getQuantityAll = function () {
        var that = this;
        return that.__countItemsQuantity(that.seats_selected_unpaid);
    };

    SvcsScreenSeats.prototype.__countItemsQuantity = function (items) {
        if (!items.length) {
            return 0;
        }
        return items.reduce(function (quantity, selection) {
            return quantity + parseInt(selection['item_quantity'], 10);
        }, 0);
    };

    SvcsScreenSeats.prototype.__recalcSvcTotal = function (total, value, multiplier = 1) {
        total = parseFloat(total);
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var amount = value * multiplier;

        if (amount < 0 && total < Math.abs(amount)) {
            $.sa.log('Error count total svcs price');
        } else {
            total += value * multiplier;
        }
        return total;
    };

    SvcsScreenSeats.prototype.__formatTotalPrice = function (total) {
        var that = this;
        return $.sa.format.price(total, that.order_currency);
    };

    SvcsScreenSeats.prototype.__displaySvcTotal = function (total) {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        that.$add_drawer_total.text(that.__formatTotalPrice(total));
    };

    SvcsScreenSeats.prototype.isRenderedSeatsIncompleteWarning = function (screen_id, next_screen_id) {
        var that = this;

        if (!that.seats_incomplete_warning_enable || screen_id !== 'seats') {
            return false;
        }
        
        if (that.__isSeatsIncomplete()) {
            that.__renderSeatsIncompleteWarningModal(next_screen_id);
            return true;
        }
        
        return false;
    };

    SvcsScreenSeats.prototype.__isSeatsIncomplete = function () {
        var that = this,
            svcs_selected = that.seats_selected_unpaid,
            svcs_selected_clear;
        
        if (that.seats_selected_paid.length) {
            svcs_selected = that.seats_selected_paid.concat(svcs_selected);
        }

        svcs_selected_clear = PageSvcs.prototype.svcsSelectedCleanSort(svcs_selected);
        
        if (!svcs_selected_clear.length) {
            return false;
        }

        for(var order_passenger_id of that.order_passengers_ids) {
            var passenger_id = parseInt(order_passenger_id, 10),
                passenger_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                    return parseInt(svc_selected.passenger_id, 10) === passenger_id;
                });

            if (passenger_matched === -1) {
                continue;
            }

            // If there is a match by passenger_id in the svcs_selected_clear array,
            // then check is there a match in each segment
            for (var order_segment_id of that.order_segments_ids) {
                var segment_id = parseInt(order_segment_id, 10),
                    segment_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                        return  parseInt(svc_selected.passenger_id, 10) === passenger_id &&
                                parseInt(svc_selected.segment_id, 10) === segment_id;
                    });

                // if segment matched remove object with this segment from array for next loop check
                if (segment_matched !== -1) {
                    svcs_selected_clear.splice(segment_matched, 1);
                }

                if (segment_matched === -1 && that.isChairAvailable(that, segment_id)) {
                    return true;
                }
            }
        }
        
        return false;
    };

    SvcsScreenSeats.prototype.__renderSeatsIncompleteWarningModal = function (next_screen_id) {
        var that = this;
        
        $.uiModal({
            html: that.seats_incomplete_warning_html,
            onCancelClosed: function () {
                that.onSeatsIncompleteWarningCancelClosed(next_screen_id);
            }
        });
    };

    SvcsScreenSeats.prototype.isRenderedSeatsEmptyWarning = function (screen_id, next_screen_id, order_passengers_count, order_segments_count) {
        var that = this,
            chair_available = false,
            segments_with_seats_available_count = 0;

        if (!that.seats_empty_warning_enable || screen_id !== 'seats') {
            return false;
        }
        
        that.order_segments_ids.forEach(function (segment_id) {
            if (that.isChairAvailable(that, segment_id, order_passengers_count)) {
                segments_with_seats_available_count++;
            }
        });

        if (
            segments_with_seats_available_count === order_segments_count &&
            !that.seats_empty_modal_disallow &&
            that.__isSeatsEmpty()
        ) {
            that.__renderSeatsEmptyModal(next_screen_id);
            return true;
        }
        
        return false;
    };

    SvcsScreenSeats.prototype.__isSeatsEmpty = function () {
        var that = this,
            seats_svc_selected_clear = PageSvcs.prototype.svcsSelectedCleanSort(that.seats_selected_unpaid);

        return !seats_svc_selected_clear.length;
    };

    SvcsScreenSeats.prototype.__renderSeatsEmptyModal = function (next_screen_id) {
        var that = this;
        
        $.uiModal({
            html: that.seats_empty_warning_html,
            onCancelClosed: function () {
                that.onSeatsEmptyWarningCancelClosed(next_screen_id);
            },
            onButtonConfirmClick: function (){
                that.seats_empty_modal_disallow = true;
            }
        });
    };

    SvcsScreenSeats.prototype.isChairAvailable = function (component, segment_id, passengers_count = 1) {
        var that = this,
            $segment_seatmap_chairs = null,
            seats_count = 0;

        if (!component.seatmaps) {
            return false
        }
        
        for (var seatmap of component.seatmaps) {
            if (parseInt(seatmap.segment_id, 10) !== parseInt(segment_id, 10)) {
                continue;
            }

            if ($segment_seatmap_chairs) {
                break;
            }
            
            $segment_seatmap_chairs = seatmap.$chairs;
            $segment_seatmap_chairs.each(function () {
                var $chair = $(this);

                if (UISeatmap.prototype.isChairAvailable($chair)) {
                    seats_count++;
                }
            });
        }
        
        return seats_count >= passengers_count;
    };

    return SvcsScreenSeats;
})($);